export const dataNews24h = [
  {
    id: 1,
    image:
      "https://cdn.tgdd.vn/Files/2022/07/28/1451069/shopeepay_1280x720-300x200.jpg",
    title:
      "Nhập mã SPPMWG giảm 10% tối đa 100K khi thanh toán qua ví ShopeePay",
    time: "15 phút trước",
  },
  {
    id: 1,
    image:
      "https://cdn.tgdd.vn/Files/2022/08/04/1453231/samsung-galaxy-flex-mode_1280x720-300x200.jpg",
    title:
      "Liệu trải nghiệm chơi game trên Galaxy Z thế hệ mới sẽ được cải tiến hơn?",
    time: "27 phút trước",
  },
  {
    id: 1,
    image:
      "https://cdn.tgdd.vn/Files/2022/08/02/1452743/thumb3_800x450-300x200.jpg",
    title:
      "Nghe Đồn Là: Redmi 11 Prime 5G dùng Snapdragon 720G, sạc nhanh 33 W, giá 5 triệu (liên tục cập nhật)",
    time: "34 phút trước",
  },
  {
    id: 1,
    image:
      "https://cdn.tgdd.vn/Files/2022/08/04/1453215/ticketmaster-tgdd-1-2-3_1280x720-300x200.jpg",
    title:
      "TikTok, Ticketmaster ra tính năng giúp người dùng 'Gen Z' đặt vé sự kiện trên app",
    time: "1 giờ trước",
  },
  {
    id: 1,
    image:
      "https://cdn.tgdd.vn/Files/2022/07/06/1445325/cach-ngan-theo-doi-email-trong-gmail-08_800x450-300x200.jpg",
    title:
      "Cách ngăn theo dõi email trong Gmail đơn giản, nhanh chóng, tiện lợi dành cho bạn",
    time: "1 giờ trước",
  },
];
